module.exports = __webpack_public_path__ + "static/media/step.8781c7c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toolbar/icons/step.svg
// module id = 916
// module chunks = 53